<template>
  <div class="taxonomy-breakdown">
    <div class="taxonomy-breakdown-header">
      <div class="left-block">
        <span class="title">Taxonomy</span>

        <div class="controls">
          <el-select
            v-if="isCookieThird"
            v-model="value"
            placeholder="Source"
            :disabled="true"
            size="mini"
            class="select-item"
          >
            <el-option
              v-for="(item, index) in items"
              :key="index"
              :label="item"
              :value="item"
              :disabled="taxonomiesBreakdownLoading"
            />
          </el-select>

          <el-select
            v-else
            v-model="selectedTaxoId"
            placeholder="Choose a taxonomy"
            size="mini"
            class="select-item"
            :disabled="taxonomiesBreakdownLoading"
            @change="handleTaxonomyChange"
          >
            <el-option
              v-for="taxonomy in customTaxonomiesOptions"
              :key="taxonomy.value"
              :label="taxonomy.label"
              :value="taxonomy.value"
            />
          </el-select>
        </div>
      </div>
      <div class="right-block">
        <span :class="{ 'isSelected': !isCookieThird }">1st Party</span>
        <SwitchItem
          :is-switch-active="true"
          class="switch-size"
          :class="{'ui-disabled': breakdownLoading || taxonomiesBreakdownLoading }"
          label=""
          input-name="1rd-party-switch"
          @change="handleTypeOfCookie"
        />
        <span :class="{ 'isSelected': isCookieThird }">3rd Party</span>
      </div>
    </div>

    <div class="content-wrapper">
      <div v-if="isCookieThird" class="tree-map-container">
        <div class="tree-map-section">
          <TaxonomyBreakdown
            :data="percentBreakdown"
            :is-loading="breakdownLoading"
            title="User %"
            subtitle="Based on 3rd party customer data"
            error-message="No distribution data available."
          />
        </div>

        <div class="tree-map-section">
          <TaxonomyBreakdown
            :data="affinityBreakdown"
            :is-loading="breakdownLoading"
            title="Affinity"
            subtitle="Based on 3rd party customer data"
            error-message="No distribution data available."
          />
        </div>
      </div>

      <div v-if="!isCookieThird" class="tree-map-container">
        <div class="tree-map-section">
          <TaxonomyBreakdown
            :data="taxonomiesBreakdownPurcent"
            :is-loading="taxonomiesBreakdownLoading"
            :is-cookie-first="!isCookieThird"
            title="User %"
            subtitle="Based on 1st party customer data"
            error-message="No percent data available."
          />
        </div>

        <div class="tree-map-section">
          <TaxonomyBreakdown
            :data="taxonomiesBreakdownAffinity"
            :is-loading="taxonomiesBreakdownLoading"
            :is-cookie-first="!isCookieThird"
            title="Affinity"
            subtitle="Based on 1st party customer data"
            error-message="No affinity data available."
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import TaxonomyBreakdown from './TaxonomyBreakdown.vue'
import SwitchItem from '@/components/common/SwitchItem'

export default {
    name: 'TaxonomyDashboard',
    components: { TaxonomyBreakdown, SwitchItem },

    data: () => ({
        items: ['Weborama'],
        value: 'Weborama',
        selectedTaxoId: '',
        isCookieThird: true,
    }),

    computed: {
        ...mapGetters('dashboardAccount', [
            'affinityBreakdown',
            'percentBreakdown',
            'breakdownLoading',
            'taxonomiesBreakdownAffinity',
            'taxonomiesBreakdownPurcent',
            'taxonomiesBreakdownLoading'
        ]),
        ...mapState('data/customTaxonomies', {
            customTaxonomies: state => state.customTaxonomies,
        }),
        customTaxonomiesOptions() {
            return this.customTaxonomies.map(taxo => ({
                value: taxo.id,
                label: taxo.label
            }))
        }
    },

    watch: {
        customTaxonomiesOptions: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.length > 0 && !this.selectedTaxoId) {
                    this.selectedTaxoId = newVal[0].value
                }
            }
        },
        selectedTaxoId(newValue) {
            if (newValue) {
            //this.retrieveHierarchyOfSelectedTaxonomy({ newValue })
                this.getTaxonomiesBreakdown({ taxonomyId: newValue })
            }
        },
        isCookieThird(newValue) {
            if (!newValue && this.selectedTaxoId) {
                this.getTaxonomiesBreakdown({ taxonomyId: this.selectedTaxoId })
            }
        }
    },

    methods: {
        ...mapActions('ui/manageTaxonomy', ['retrieveHierarchyOfSelectedTaxonomy']),
        ...mapActions('dashboardAccount', ['getTaxonomiesBreakdown']),

        handleTaxonomyChange(value) {
            this.getTaxonomiesBreakdown({ taxonomyId: value })
        },
        handleTypeOfCookie(e) {
            this.isCookieThird = e
        }
    }
}
</script>

<style lang="scss" scoped>
.taxonomy-breakdown {
  display: flex;
  flex-direction: column;
  height: 100%;
  .taxonomy-breakdown-header {
    display: flex;
    background: #fff;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    box-sizing: border-box;
    flex-shrink: 0;
    margin-bottom: 24px;

    .left-block {
      display: flex;
      align-items: center;
    }

    .right-block {
      display: flex;
      align-items: center;
      gap: 10px;

      .isSelected {
        font-weight: bold;
      }
    }

    .title {
      margin: 0;
      font-size: 1.25rem;
      color: #333;
    }

    .controls {
      display: flex;
      gap: 10px;
      margin-left: 10px;

      .select-item {
        width: 200px;
        height: 28px;
      }
    }
  }
}

.content-wrapper {
  position: relative;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.tree-map-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 2rem;

  .tree-map-section {
    display: flex;
    flex: 1;
    min-width: 0;
    height: 100%;

      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background: #e0e0e0;
        border-radius: 10px;
      }
    }
  }

.no-data {
  padding-top: 50px;
  text-align: center;
  color: #999;
  font-style: italic;
  font-size: 0.85rem;
}

@media (max-width: 992px) {
  .tree-map-container {
    flex-direction: column;
  }
}
</style>
